import { BreakpointObserver, MediaMatcher } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild, ViewEncapsulation, ChangeDetectorRef, HostListener, AfterViewInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatSidenav } from '@angular/material/sidenav';
import { CoreService } from '../../services/core.service';
import { AppSettings, defaults } from '../../app.config';
import { navItems } from './vertical/sidebar/sidebar-data';
import { NavService } from '../../services/nav.service';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { AppHorizontalSidebarComponent } from './horizontal/sidebar/sidebar.component';
import { BrandingComponent } from './vertical/sidebar/branding.component';
import { AppBreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import { CustomizerComponent } from './shared/customizer/customizer.component';
import { MaterialModule } from '../../material.module';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AppNavItemComponent } from './vertical/sidebar/nav-item/nav-item.component';
import { AuthService } from '@auth-suite-services/services';

const MOBILE_VIEW = 'screen and (max-width: 768px)';
const TABLET_VIEW = 'screen and (min-width: 769px) and (max-width: 1024px)';
const MONITOR_VIEW = 'screen and (min-width: 1024px)';
const BELOWMONITOR = 'screen and (max-width: 1023px)';
@Component({
  selector: 'app-full',
  templateUrl: './full.component.html',
  standalone: true,
  imports: [
    NgScrollbarModule,
    AppHorizontalSidebarComponent,
    BrandingComponent,
    AppBreadcrumbComponent,
    CustomizerComponent,
    MaterialModule,
    RouterModule,
    CommonModule,
    AppNavItemComponent
],
  styleUrls: [],
  encapsulation: ViewEncapsulation.None
})
// See C002 - 2026-08-11 - HE
// export class FullComponent implements OnInit {
export class FullComponent implements OnInit, AfterViewInit {
  navItems = navItems;
  @ViewChild('leftsidenav')
  public sidenav: MatSidenav;
  resView = false;
  //get options from service
  // See C001 - 2026-01-22 - HE
  // options = this.settings.getOptions();
  options!: AppSettings;
  navopt = this.navService.showClass;
  private layoutChangesSubscription = Subscription.EMPTY;
  private isMobileScreen = false;
  private isContentWidthFixed = true;
  private isCollapsedWidthFixed = false;
  private htmlElement!: HTMLHtmlElement;
  // env/appVersion credit moved to home dashboard 28/10/2026 DW
  test: Date = new Date();

  // See C002 - 2026-08-11 - HE
  // Skip detectChanges until the view exists (BreakpointObserver emits in the constructor).
  private viewInitialized = false;

  // CHANGE: Add zoom-aware viewport detection - 2025-10-01 - HE
  // private actualViewportWidth = window.innerWidth;
  private actualViewportWidth = window.innerWidth;

  get isOver(): boolean {
    // CHANGE: Use actual viewport width instead of CSS breakpoints for zoom accuracy - 2025-10-01 - HE
    // return this.isMobileScreen;
    return this.actualViewportWidth <= 768;
  }

  get isTablet(): boolean {
    // CHANGE: Use actual viewport width for tablet detection - 2025-10-01 - HE
    // return this.resView;
    return this.actualViewportWidth <= 1023;
  }

  constructor(
    private settings: CoreService,
    private mediaMatcher: MediaMatcher,
    private navService: NavService,
    private breakpointObserver: BreakpointObserver,
    // CHANGE: Trigger CD on breakpoint changes to stabilize sidenav after zoom - 2025-10-01 - HE
    // private cdr: ChangeDetectorRef
    private cdr: ChangeDetectorRef,
    // Logout moved from topbar into sidebar 28/10/2026 DW
    public authService: AuthService
  ) {
    // See C001 - 2026-01-22 - HE
    // Initialize options in constructor to ensure it's never null
    this.options = this.settings.getOptions() || { ...defaults };
    this.htmlElement = document.querySelector('html')!;
    this.layoutChangesSubscription = this.breakpointObserver
      .observe([MOBILE_VIEW, TABLET_VIEW, MONITOR_VIEW, BELOWMONITOR])
      .subscribe((state) => {
        // SidenavOpened must be reset true when layout changes
        this.options.sidenavOpened = true;
        this.isMobileScreen = state.breakpoints[MOBILE_VIEW];

        // CHANGE: Don't auto-collapse sidebar on tablet view to prevent hover-only content - 2025-10-01 - HE
        // if (this.options.sidenavCollapsed == false) {
        //   this.options.sidenavCollapsed = state.breakpoints[TABLET_VIEW];
        // }
        if (this.options.sidenavCollapsed == false) {
          // Only collapse on actual mobile screens, not tablet/zoom
          this.options.sidenavCollapsed = state.breakpoints[MOBILE_VIEW];
        }
        this.isContentWidthFixed = state.breakpoints[MONITOR_VIEW];
        this.resView = state.breakpoints[BELOWMONITOR];
        // CHANGE: Force a CD tick so that mat-sidenav recalculates mode/opened after zoom - 2025-10-01 - HE
        // this.cdr.detectChanges();
        // See C002 - 2026-08-11 - HE
        // this.cdr.detectChanges();
        this.safeDetectChanges();
      });

    // Initialize project theme with options
    this.receiveOptions(this.options);
  }

  ngOnInit(): void {
    // CHANGE: Initialize viewport width on component init - 2025-10-01 - HE
    // this.updateViewportWidth();
    this.updateViewportWidth();

    // CHANGE: Ensure sidebar is properly expanded on init - 2025-10-01 - HE
    // if (this.actualViewportWidth > 768) {
    if (this.actualViewportWidth > 768) {
      this.options.sidenavOpened = true;
      this.options.sidenavCollapsed = false;
      this.settings.setOptions(this.options);
    }
  }

  // See C002 - 2026-08-11 - HE
  ngAfterViewInit(): void {
    this.viewInitialized = true;
  }

  ngOnDestroy() {
    this.layoutChangesSubscription.unsubscribe();
  }

  // See C002 - 2026-08-11 - HE
  // BreakpointObserver emits synchronously in the constructor; detectChanges before the
  // view exists throws TypeError: Cannot read properties of null (reading 'options').
  private safeDetectChanges(): void {
    if (!this.viewInitialized) {
      return;
    }
    this.cdr.detectChanges();
  }

  // CHANGE: Add window resize listener for zoom changes - 2025-10-01 - HE
  // @HostListener('window:resize', ['$event'])
  @HostListener('window:resize', ['$event'])
  onWindowResize(event: any) {
    this.updateViewportWidth();
  }

  private updateViewportWidth() {
    // CHANGE: Update viewport width and trigger change detection - 2025-10-01 - HE
    // this.actualViewportWidth = window.innerWidth;
    this.actualViewportWidth = window.innerWidth;

    // CHANGE: Ensure sidebar doesn't get collapsed incorrectly on zoom - 2025-10-01 - HE
    // if (this.actualViewportWidth > 768 && this.options.sidenavCollapsed) {
    if (this.actualViewportWidth > 768 && this.options.sidenavCollapsed) {
      this.options.sidenavCollapsed = false;
      this.settings.setOptions(this.options);
    }

    // See C002 - 2026-08-11 - HE
    // this.cdr.detectChanges();
    this.safeDetectChanges();
  }

  toggleCollapsed() {
    this.isContentWidthFixed = false;
    this.options.sidenavCollapsed = !this.options.sidenavCollapsed;
    this.resetCollapsedState();
  }

  resetCollapsedState(timer = 400) {
    setTimeout(() => this.settings.setOptions(this.options), timer);
  }

  onSidenavClosedStart() {
    this.isContentWidthFixed = false;
  }

  onSidenavOpenedChange(isOpened: boolean) {
    this.isCollapsedWidthFixed = !this.isOver;
    this.options.sidenavOpened = isOpened;
    this.settings.setOptions(this.options);
  }

  receiveOptions(options: AppSettings): void {
    // See C002 - 2026-08-11 - HE
    // if (!options) return — avoid wiping options when customizer emits unexpectedly.
    if (!options) {
      return;
    }
    this.options = options;
    this.toggleDarkTheme(options);
  }

  toggleDarkTheme(options: AppSettings) {
    if (options.theme === 'dark') {
      this.htmlElement.classList.add('dark-theme');
      this.htmlElement.classList.remove('light-theme');
    } else {
      this.htmlElement.classList.remove('dark-theme');
      this.htmlElement.classList.add('light-theme');
    }
  }
}

// ========================================
// CHANGE LOG
// ========================================
// C001: Fixed null reference error by initializing options property in constructor instead of property initializer. Previous behavior: options was initialized as `options = this.settings.getOptions()` at class property level, which could potentially be null or undefined when the template tried to access `options.sidenavCollapsed`, `options.horizontal`, etc., causing "Cannot read properties of null (reading 'options')" error at full.component.html:4:3. New behavior: options is now declared as `options!: AppSettings` and initialized in the constructor with `this.options = this.settings.getOptions() || defaults`, ensuring it always has a valid value before the template renders. Also imported `defaults` from app.config.ts to provide a fallback value. Reason: Runtime error preventing component from rendering properly when accessing options properties in template. Context: Error occurred when accessing the merchantadmin/pln route. Impact: Prevents null reference errors, ensures options is always initialized with valid AppSettings object, no breaking changes to functionality. - 2026-01-22 - HE
// C002: Stopped calling ChangeDetectorRef.detectChanges() before the view exists. Previous behavior: BreakpointObserver.observe() emits synchronously inside the FullComponent constructor and immediately called this.cdr.detectChanges(); ngOnInit/updateViewportWidth also called detectChanges before AfterViewInit. That ran template bindings while the component LView/context was still null, producing TypeError: Cannot read properties of null (reading 'options') at full.component.html:4:3 (stack: full.component.ts constructor subscribe → detectChanges). New behavior: Added viewInitialized flag set in ngAfterViewInit; safeDetectChanges() no-ops until then; breakpoint and viewport handlers use safeDetectChanges(); receiveOptions ignores null/undefined payloads; options fallback uses a shallow copy of defaults. Reason: Runtime crash on load (uat-setup.suredebit.co.za) when opening the full layout / navigating toward Access. Context: User console error with dashboard1 loadSPSInstructions continuing afterward. Impact: Layout initializes without the null options template crash; later resize/breakpoint detectChanges still runs after the view is ready. - 2026-08-11 - HE
